import { render, staticRenderFns } from "./AllergicRhinitis.vue?vue&type=template&id=c964475a"
import script from "./AllergicRhinitis.vue?vue&type=script&lang=js"
export * from "./AllergicRhinitis.vue?vue&type=script&lang=js"
import style0 from "./AllergicRhinitis.vue?vue&type=style&index=0&id=c964475a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports